import type { IntercomTokenResponse } from "@/lib/intercom/types"

export function isIntercomTokenResponse(value: unknown): value is IntercomTokenResponse {
  if (!value || typeof value !== "object") {
    return false
  }

  const data = value as IntercomTokenResponse
  return (
    typeof data.intercom_jwt === "string" &&
    typeof data.expires_at === "number" &&
    Number.isFinite(data.expires_at) &&
    typeof data.user_id === "string" &&
    Boolean(data.attributes) &&
    typeof data.attributes.email === "string"
  )
}
